import React, { useState, useEffect } from 'react';

import { Form, Modal, Radio, Typography, message } from 'antd';
import SPStoreDistance from '../SPStoreDistance';

// import request  from '../../../service/Base'
// import { API_PLAN_CHANGE_STATUS } from '../../../service/Plans'

import { sameCityPRCarOpen } from 'hooks/carRental/store';

import emiter, {
  EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY,
  EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL, EVENT_CARRENTAL_STORE_DAY_OFF, EVENT_CARRENTAL_UPDATE_DAY_OFF_LIST,
} from '../../../../events'

interface PropsType {
  enums?: any;
}

const { Text } = Typography

const SPSamCityRemoteReturnModal: React.FC<PropsType> = (props) => {
  const { enums } = props


  const [mainForm] = Form.useForm();
  const [data, setData] = useState<any>();
  const [open, setOpen] = useState(false);
  const [newEnums, setNewEnums] = useState([])
  const [isCharge, setIsCharge] = useState(1)
  const [modelWidth, setModelWidth] = useState(930);

  const onOpen = (data: any) => {
    // drawer打开的同时去更改状态，所以关闭drawer
    // emiter.emit(EVENT_TRAVEL_CLOSE_DRAWER_PLAN);
    setData(data)
    setOpen(true);
    if (data) {
      mainForm.setFieldsValue({
        need_pay: data?.need_pay,
        pay_conf: data?.pay_conf,
      });
    }
  };

  const onClose = () => {
    mainForm.resetFields()
    setOpen(false);
  };

  const handleOk = () => {
    mainForm.validateFields().then((values: any) => {
      const { need_pay, pay_conf } = values || {};
      (pay_conf || []).forEach((item: any) => {
        if (!item.max_kilo) {
          item.max_kilo = 10000;
        }
        if (item.fee) {
          item.fee = item.fee * 100;
        }
      });
      sameCityPRCarOpen({
        need_pay,
        pay_conf,
      }).then((res: any) => {
        const { errno } = res || {};
        if (errno === 0) {
          setOpen(false);
          message.success('操作成功');
          emiter.emit(EVENT_CARRENTAL_DIFF_PR_CAR_DETAIL);
        }
      })
    })
  };

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY, onOpen);
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_OPEN_STOREMANAGEMENT_SAMCITY)
    }
  }, []);


  useEffect(() => {
    // setNewEnums(enums?.packageStatus?.filter((item: any) => item.key != data.packageStatus) || [])
    if (open) {
      setIsCharge(data?.need_pay);
    }
  }, [open]);

  const onIsCharge = (e: any) => {
    const value = e.target.value;
    if (value) {
      setModelWidth(930);
    } else {
      setModelWidth(500);
    }
    setIsCharge(value);
  }

  return (
    <Modal width={modelWidth} title="是否收取费用" open={open} onOk={handleOk} onCancel={onClose}>
      <Form form={mainForm}>
        <Form.Item name="need_pay" label="是否收取费用" >
          <Radio.Group onChange={onIsCharge}>
            <Radio value={1}>是</Radio>
            <Radio value={2}>否</Radio>
          </Radio.Group>
        </Form.Item>
        {isCharge === 1 &&
          <>
            <Text>门店间距离根据两点间直线距离计算</Text>
            <Form.Item name="pay_conf">
              <SPStoreDistance enums={enums} />
            </Form.Item>
          </>
        }
      </Form>
    </Modal>
  );
}

export default SPSamCityRemoteReturnModal;
